export default {
  columns: {
    strategy: 'Stratégie',
    source: 'Source',
    async: 'Async',
    content: 'Contenu',
    edit: 'Modifier',
    delete: 'Supprimer',
  },
  buttons: {
    add_script: 'Ajouter un script',
  },
};
